import React from "react";
import ReactDOM from "react-dom";
import firebase from "firebase";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
